import * as Inovx from '@shared';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/UserApi/api/settings`;

var SettingsService: ISettingsService = { ...Inovx.Shared.Flux.BaseService, ...{
    getSettings: function (successCallback: (retData: IUserAppSetting) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(`${url}/Authentication`,
            null,
            (retData: any) => {
                successCallback(retData);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    saveSettings: function (settings: IUserAppSetting, successCallback: () => void, errorCallback: IErrorCallback, ignoreVSuiteLoginError?: boolean) {
        this.post(`${url}/Authentication`,
            settings,
            (data: any) => {
                successCallback();
            },
            (error: any) => {
                var errJson = JSON.parse(error.responseText);
                if (ignoreVSuiteLoginError) {
                    if (errJson.Reason != "CurrentUserPasswordNotSet") {
                        this.handleWebApiError(error);
                    }
                }
                else {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    getSystemSettings: function (successCallback: (retData: IUserSystemSetting) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(`${url}/System`,
            null,
            (retData: any) => {
                successCallback(retData);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    saveSystemSettings: function (settings: IUserSystemSetting, successCallback: () => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.post(`${url}/System`,
            settings,
            (data: any) => {
                successCallback();
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    }
}};

export default SettingsService;
